@if (extendedItems(); as extendedItems) { @if (extendedItems.length) {
<div class="ui-simple-table" [libFlexRow]="true" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'start'">
	@for (item of extendedItems; track item.title+item.value; let first = $first; let last = $last) {
	<div libFlexColumn [style.width]="calculateFlexWidth(columnsPerRowCalculated(), 16)">
		<div libFlexRow [libFlexRowAlign]="'start'" [libFlexRowGap]="'16px'">
			<div libFlexColumn [libFlexSize]="'fill'">
				@if (item.displayTitle) {
				<div class="push-bottom-sm">
					<div
						libFlexRow
						[libFlexRowGap]="'12px'"
						[libText3]="titleFontType() === 'text3'"
						[class.title-opacity]="titleFontType() === 'opacity'"
					>
						@if (item.iconType) {
						<div libFlexColumn>
							<lib-icon [type]="item.iconType"></lib-icon>
						</div>
						}
						<div libFlexColumn libFlexFill>
							<div libLineClamp [clampLines]="2">{{ item.title }}</div>
						</div>
					</div>
				</div>
				}

				<div class="ui-item-value">
					@if (item.value) {
					<lib-link
						[routerLink]="item.routerLink"
						[externalUrl]="item.externalUrl"
						[linkStyle]="item.valueType === 'tag' ? 'noUnderline' : 'default'"
					>
						@if (item.valueType === 'html') {
						<div libWordBreak [innerHTML]="item.value | textToHtml"></div>
						} @else if (item.valueType === 'text') {
						<div libWordBreak>{{ item.value }}</div>
						} @else if (item.valueType === 'tag') {
						<lib-tag [tagType]="item.tagType ?? 'basic'">{{ item.value }}</lib-tag>
						} @else {
						<div>Not supported value type</div>
						}
					</lib-link>
					} @if (item.images?.length) {
					<div libFlexRow [libFlexRowGap]="'16px'">
						@for (image of item.images; track image.image.originalImage.absoluteUrl) {
						<div libFlexColumn [libFlexSize]="'50px'">
							<lib-image
								[isResponsive]="false"
								[dialogPreviewImage]="image.image"
								[alt]="image.title ?? 'List item avatar'"
								[imageSize]="'50px'"
								[image]="image.image"
								[isRound]="false"
							></lib-image>
						</div>
						}
					</div>
					} @if (item.videoUrl) {
					<lib-video [url]="item.videoUrl"></lib-video>
					}
				</div>
			</div>
			@if (item.buttons && item.buttons.length) {
			<div libFlexColumn>
				<lib-button-list
					[buttons]="item.buttons"
					[mode]="'extendedList'"
					[extendListThreshold]="2"
				></lib-button-list>
			</div>
			}
		</div>
		@if (item.displayDivider) {
		<lib-divider class="push-top"></lib-divider>
		}
	</div>
	}
</div>
} }
